<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 审核流程 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.audit") }}</span>

                <div class="switch1">
                    <div class="main">
                        <p>
                            <el-button @click="tan()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.audit5") }}</el-button>
                        </p>
                    </div>
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName">
                            <el-table-column prop="AUDIT_NAME" :label="$t('logs.audit1')">
                            </el-table-column>
                            <el-table-column prop="FIRST_AUDIT" :label="$t('logs.audit2')">
                            </el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除-->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                    <!-- 编辑审核流程-->

                                    <el-button @click="bianji1(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.audit3") }}</el-button>
                                    <!-- 快编辑审核策略-->

                                    <el-button @click="bianji2(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.audit4") }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_local_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain_edit"><span class="span_pad"></span> {{$t('logs.audit5')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{$t('logs.audit1')}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="audit_name" placeholder="数字与字母的组合"></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{$t('logs.audit2')}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="first_audit" placeholder="邮箱账户地址"></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_add()">{{ $t("logs.save_a") }}</el-button>
                            <el-button type="danger" @click="tanOff()">{{ $t("logs.save_b") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <!-- 编辑流程 -->
                    <div class="pop-up" v-show="tanchu1"  v-drag ="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.audit3')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{$t('logs.audit1')}}:
                                </div>
                                <div class="block block1">
                                    <p style="text-align:left;color:#0e2c5e">{{this.audit_name_edit}}</p>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{$t('logs.audit2')}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="first_audit" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_first_edit()">{{ $t("logs.save_a") }}</el-button>
                            <el-button type="danger" @click="cancel_first_edit()">{{ $t("logs.save_b") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu1"></div>
                    <div class="pop-up" v-show="tanchu2" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.audit4')}}</div>
                        <p></p>

                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{$t('logs.audit1')}}:
                                </div>
                                <div class="block block1">
                                    <p style="text-align:left;color:#0e2c5e">{{this.audit_name_edit}}</p>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{$t('logs.audit7')}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="audit_rule" placeholder=""></el-input>
                                    <el-alert :title="$t('logs.audit8')" type="warning" show-icon :closable="false"></el-alert>
                                </div>
                            </div>
                            <div class="find1">
                                <!--方向 -->
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.Policy_list8") }}:
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="direct">
                                        <el-radio :label="1"> {{ $t("logs.group7_a11") }}</el-radio>
                                        <el-radio :label="2">{{ $t("logs.group7_a12") }}</el-radio>
                                        <el-radio :label="3">{{ $t("logs.group7_a8") }}</el-radio>

                                    </el-radio-group>

                                </div>
                            </div>
                            <div class="find1">
                                <!--激活 -->
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.Policy_list9") }}:
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="active">
                                        <el-radio :label="1"> {{ $t("logs.Policy_comb12") }}</el-radio>
                                        <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>

                                    </el-radio-group>

                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_second_edit()">{{ $t("logs.save_a") }}</el-button>
                            <el-button type="danger" @click="cancel_second_edit()">{{ $t("logs.save_b") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu2"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            active: '',
            audit_rule: '',
            direct: 1,
            audit_name_edit: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            tanchu1: false,
            tanchu2: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            radio: [],
            first_audit: '',
            audit_name: '',
        };
    },
    mounted() {
        this.getFileList()
    },
    methods: {
        // 编辑策略
        save_second_edit() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_audit_policy",
                sid: sid,
                audit_rule: this.audit_rule,
                audit_name: this.audit_name_edit,
                direct: this.direct,

                active: this.active,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu2 = false
                        this.getFileList()
                        // 总条数
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                    }
                })
                
        },
        cancel_second_edit() {
            this.tanchu2 = false

        },
        // 编辑流程保存
        save_first_edit() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_audit_comb",
                sid: sid,
                first_audit: this.first_audit,
                audit_name: this.audit_name_edit,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu1 = false
                        this.getFileList()
                        // 总条数

                    }
                })
                
        },
        cancel_first_edit() {
            this.tanchu1 = false

        },
        // 编辑审核策略
        bianji2(index, scope) {
            // console.log(index, scope);
            this.audit_name_edit = scope.AUDIT_NAME
            this.audit_rule = scope.AUDIT_RULE
            this.direct = scope.DIRECT
            this.active = scope.ACTIVE

            this.tanchu2 = true
        },
        // 编辑审核流程
        bianji1(index, scope) {
            // console.log(index, scope);
            this.audit_name_edit = scope.AUDIT_NAME
            this.first_audit = scope.FIRST_AUDIT
            this.tanchu1 = true
        },
        // 删除1
        handleClick1(index, scope) {
            // console.log(index, scope);
            this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let audit_name = scope.AUDIT_NAME;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_audit_comb",
                                sid: sid,
                                audit_name: audit_name,

                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("anti_gs1_tan.del1")}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("anti_gs1_tan.del2")}`,
                    });
                });
        },
        // 编辑
        save_add() {

            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_audit_comb",
                sid: sid,
                first_audit: this.first_audit,
                audit_name: this.audit_name,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res)
                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.getFileList()
                        // 总条数

                    }
                })
                
        },
        // 加载

        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_audit_comb",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList = res.data.ret.datalist;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },

        // 显示
        tan: function () {
            this.tanchu = true;
            this.audit_name = ''
            this.first_audit = ''
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-table {
    height: calc(70vh - 30px);
}

/deep/ .el-tabs__nav {
    padding-left: 16px;
}
</style>
